import { Time } from "@/lib/Time";
export class TimerCore {
  accumulator = 0;
  startTimestamp = null;
  creationTimestamp = null;

  setData({
    accumulator = 0,
    startTimestamp = null,
    creationTimestamp = null
  } = {}) {
    this.accumulator = accumulator;
    this.startTimestamp = startTimestamp;
    this.creationTimestamp = creationTimestamp;
  }

  start() {
    // Timestamp can not be Date since Vue adds ob to watch date object and it destroys moment's
    // ability to compute
    if (this.status == "READY") {
      this.creationTimestamp = Time.date.getNow();
    }
    if (this.status !== "RUNNING") {
      this.startTimestamp = Time.date.getNow();
    }
  }

  pause() {
    if (this.status == "RUNNING") {
      this.accumulator = this.elapsedTime;
      this.startTimestamp = null;
    }
  }

  clear() {
    this.accumulator = 0;
    this.startTimestamp = null;
    this.creationTimestamp = null;
  }

  get elapsedTime() {
    if (this.status == "RUNNING") {
      return (
        this.accumulator +
        Time.duration.diff(Time.date.getNow(), this.startTimestamp)
      );
    } else {
      return this.accumulator;
    }
  }

  get data() {
    return {
      accumulator: this.accumulator,
      startTimestamp: this.startTimestamp,
      creationTimestamp: this.creationTimestamp
    };
  }
  get status() {
    if (this.creationTimestamp === null) {
      return "READY";
    } else if (this.startTimestamp === null) {
      return "PAUSED";
    } else {
      return "RUNNING";
    }
  }
}
